export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function createFormField(prefix, label, type, value = '') {
    const wrapper = document.createElement('label');
    wrapper.className = `${prefix}__field`;
    const labelText = document.createElement('span');
    labelText.className = `${prefix}__field-label`;
    labelText.textContent = label;
    const input = document.createElement('input');
    input.type = type;
    input.className = `${prefix}__input`;
    input.value = value;
    input.required = true;
    wrapper.append(labelText, input);
    return { wrapper, input };
}
